export default class emptyCheck {

    static emptyTohyphen = (value: any): string => {
        if(value != null) {
            return value
        } else {
            return "-"
        }
    }

}